export const ON_NOTIFICATION_HIDE = "ON_NOTIFICATION_HIDE";
